import { NgModule, provideBrowserGlobalErrorListeners } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AppRoutingModule } from "./app-routing-module";
import { App } from "./app";
import { Login } from "./account/login/login";
import { CommonModule, DatePipe, TitleCasePipe } from "@angular/common";
import { Home } from "./pages/home/home";
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { ErrorInterceptor } from "./interceptors/error.interceptor";
import { HttpInterceptor } from "./interceptors/httpInterceptors";
import { Profile } from "./account/profile/profile";
import { Registration } from "./account/registration/registration";
import { ForgotPassword } from "./account/forgot-password/forgot-password";
import { UpdateUserProfile } from "./account/update-user-profile/update-user-profile";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { Breadcrumb } from "./breadcrumb/breadcrumb";
import { MyDrive } from "./account/my-drive/my-drive";
import { Verify } from "./account/verify/verify";
import { SharedModule } from "./shared/shared-module";
import { CommonFeaturesModule } from "./pages/common-features/common-features-module";
import { VerificationModule } from "./pages/verification/verification-module";

@NgModule({
  declarations: [
    App,
    Login,
    Home,
    Profile,
    Registration,
    ForgotPassword,
    UpdateUserProfile,
    Breadcrumb,
    MyDrive,
    Verify,
   
   
  ],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    CommonFeaturesModule,
    VerificationModule
  ],
  providers: [
    provideAnimationsAsync(),
    provideBrowserGlobalErrorListeners(),
    { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    DatePipe,
    TitleCasePipe,
    provideHttpClient(withInterceptorsFromDi()),
  ],
  bootstrap: [App],
})
export class AppModule { }
